<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form class="form_cls"  :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <!-- <el-form-item label="">
        <el-input v-model="filters.ename" placeholder="姓名"></el-input>
      </el-form-item> -->
      <el-form-item label="">
        <el-input v-model="filters.Code" placeholder="岗位编码"></el-input>
      </el-form-item>
      <!-- <el-form-item label="">
         <el-select v-model="form.BU" placeholder="岗位状态">
                <el-option label="白内障" value="白内障"></el-option>
                <el-option label="飞秒激光" value="飞秒激光"></el-option>
                <el-option label="眼表" value="眼表"></el-option>
                <el-option label="白力士" value="白力士"></el-option>
              </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="医院编码">
        <el-input v-model="filters.bwacctnumber" placeholder="医院编码"></el-input>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :type="
						item.Func &&
						(item.Func.toLowerCase().indexOf('handledel') != -1 ||
							item.Func.toLowerCase().indexOf('stop') != -1)
							? 'danger'
							: 'primary'
					" v-if="!item.IsHide" @click="callFunc(item)">{{ item.name }}</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
        <div>
    <el-table border :max-height="tableHeight" :data="users" :header-cell-style="{'text-align':'center','color':'#6170d7','backgroundColor':'#F5F7FA'}" :cell-style="{'text-align':'center'}" highlight-current-row
      @current-change="selectCurrentRow" v-loading="listLoading" @selection-change="selsChange">
      <!-- <el-table-column sortable type="selection" width="50">
      </el-table-column>-->
      <el-table-column type="index" width="80">
        <template slot="header" slot-scope="{}">
          <span style="padding: 8px 0">序号 
           <span class="caret-wrapper" style="width:0px"></span>
            </span>
          <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
        </template>
      </el-table-column>
      <!-- <el-table-column sortable prop="Name" label="岗位名称" width=""></el-table-column> -->
      <el-table-column sortable prop="Code" label="岗位编码" width=""></el-table-column>
      <el-table-column sortable prop="LM_employeeposition_code" label="上级岗位编码" width=""></el-table-column>
      <!-- <el-table-column sortable prop="WWID" label="WWID" width=""></el-table-column> -->
      <!-- <el-table-column sortable prop="ENAME" label="姓名" width=""></el-table-column> -->
      <!-- <el-table-column sortable prop="Email" label="邮箱" width=""></el-table-column> -->
      <!-- <el-table-column sortable prop="RID" label="大区/小区" width=""></el-table-column> -->
      <!-- <el-table-column sortable prop="large_region_name" label="大区" width=""></el-table-column> -->
      <!-- <el-table-column sortable prop="small_region_name" label="小区" width=""></el-table-column> -->
      <el-table-column sortable prop="Level_1" label="Level 1" ></el-table-column>
      <el-table-column sortable prop="Level_2" label="Level 2" ></el-table-column>
      <el-table-column sortable prop="Level_3" label="Level 3" ></el-table-column>
      <el-table-column sortable prop="Level_4" label="Level 4" ></el-table-column>
      <!-- <el-table-column sortable prop="large_region_code" label="large_region_code" width=""></el-table-column> -->
      <!-- <el-table-column sortable prop="LineManagerPostID" label="District" width=""></el-table-column> -->
      <!-- <el-table-column sortable prop="LineManagerPostID" label="On-board date" width=""></el-table-column> -->
      <!-- <el-table-column sortable prop="small_region_code" label="small_region_code" width=""></el-table-column> -->
      <el-table-column label="操作" width="160">
        <template slot="header" slot-scope="{}">
          <span style="padding: 8px 0">操作 
           <span class="caret-wrapper" style="width:0px"></span>
            </span>
        </template>
        <template scope="scope">
          <!-- <el-link type="primary" @click="handledetails(scope.row)">
            详情
          </el-link>
          | -->
          <el-link type="primary" @click="handleEdit(scope.row)"><i class="el-icon-edit"></i>编辑</el-link>
        </template>
      </el-table-column>
    </el-table>
        </div>
    <!--工具条-->
   <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
        <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
         <el-pagination :background='true' layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total" style="float: right"></el-pagination>
        </el-col>
    </div>
        </div>
    <el-dialog :title="titles" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="editFormRules" label-width="100px" label-position="left">
        <el-form-item label="岗位编码" prop="Code">
          <el-input :disabled="titles != '新增'" v-model="form.Code" placeholder="请输入"></el-input>
        </el-form-item>
        <!-- <el-form-item label="岗位名称" prop="Name">
          <el-input v-model="form.Name" placeholder="请输入"></el-input>
        </el-form-item> -->
        <el-form-item label="大区/小区">
          <el-cascader v-if="cascader_if" v-model="form.Level_3and4" clearable :options="Employee_list" style="width: 100%" :props="{ value: 'ID', label: 'Name',checkStrictly: true }"
            @change="Level_3and4Change1"></el-cascader>
        </el-form-item>
        <!-- <el-row>
          <el-col :span="7"> -->
            <el-form-item label="上级岗位编码">
              <el-select  v-model="form.LM_employeeposition_code" filterable remote :remote-method="crystal_position_code_chage" clearable collapse-tags placeholder="请输入" style="width: 100%"  @change="crystal_position_change">
                <el-option v-for="item in crystal_position_code_options"  :label="item.Code" :value="item.Code">
                </el-option>
            </el-select>
            </el-form-item>
          <!-- </el-col>
        </el-row> -->
        <!-- <el-form-item label="PREID" prop="Type">
                <el-select  v-model="form.Type" style="width:100%" placeholder="请选择">
                <el-option label="大区" value="1"></el-option>
                <el-option label="小区" value="2"></el-option>
              </el-select>
            </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumit_station('form')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="人岗关系上传"
        :visible.sync="dialogVisible1"
        width="30%"
        :before-close="handleClose">
        <el-form ref="form1" :model="form1" :rules="editFormRules1" label-width="80px" label-position="left">
            <!-- <el-form-item label="立即生效" :required="true">
                <el-switch @change='isimediate_change' v-model="form1.isimediate"></el-switch>
            </el-form-item>
            <el-form-item label="生效日期" :required="true">
                 <el-date-picker  :disabled='form1.isimediate' v-model="form1.date" type="date" placeholder="请选择">
            </el-date-picker>
            </el-form-item> -->
            <el-upload style="display:inline-block;margin-right:20px;padding-bottom:12px"
            class="upload-demo" ref="upload" action="/images/Upload/Flie" :headers="token" :show-file-list="false"
            :on-success='handleSuccess' :before-upload='handlebefore' :on-error='handonerror'>
            <el-button type="primary">上传</el-button>
            <el-button @click="btn_up_2(form1.filepath)" v-if="form1.filepath" type="primary">预览</el-button>
          </el-upload>
          <br/>
          <el-button type="primary" @click="plmb_dc">模版导出</el-button>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible1 = false">取 消</el-button>
            <el-button type="primary" @click="plgx_submit">确 定</el-button>
        </span>
        </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date';
import {
  EmployeePosition_QueryPage,
  EmployeePosition_EmployeePositionExportExcel,
  store_data_Reback_Store,
  EmployeePosition_QueryList,
  member_overrun_ExportExcel,
  EmployeeRegionGetEmployeeRegionTrees,
  EmployeePositionAddEmployeePosition,
  EmployeePositionUpdate,
  EmployeePosition_ImportPosition
} from '../../api/api';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';

export default {
  components: { Toolbar },
  data () {
    return {
        crystal_position_code_options: [],
        form1:{
            isimediate:false,
            filepath:'',
            date:'',
        },
        cascader_if:true,
         tableHeight:0,
      token: {},
      LJGX: true,
      dialogVisible1: false,
      editFormRules1: {
        Code: [{ required: true, message: '请输入', trigger: 'blur' }],
        RID: [{ required: true, message: '请选择', trigger: 'blur' }],
        Level_3and4: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        Name: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      editFormRules: {
        Code: [{ required: true, message: '请选择', trigger: 'blur' }],
        RID: [{ required: true, message: '请选择', trigger: 'blur' }],
        Level_3and4: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        Name: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      form: {
        RID:0,
        RIDList:[]
      },
      titles: '详情',
      dialogVisible: false,
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      Employee_list: [],
    };
  },
  methods: {
    crystal_position_change(e){

     this.crystal_position_code_options.find((item)=>{
          if(item.Code === this.form.LM_employeeposition_code){
            // console.log(item)
            this.form.LM_employeeposition_id = item.ID
                // this.form.Level_3and4 = item.large_region_name+'/'+item.small_region_name
                // this.form.Level_1 = item.Level_1
                // this.form.Level_2 = item.Level_2
          }
      })
      console.log(this.form.LM_employeeposition_id)
    },
    async crystal_position_code_chage (e) {
      const { data } = await EmployeePosition_QueryList({
        code: e
      })
      this.crystal_position_code_options = data.response
      console.log(this.HospitalName_options)
      console.log(data)
    },
    btn_up_2(e){
        // console.log(this.form.file_urls)
        https://preview.51i.cc/onlinePreview?url=https://stg-jdp.51i.cc/flie/082915561111e2ff1ef57cc73cd3da78d464b58e2.png&watermarkTxt=MasterData
        window.open(
        'https://preview.51i.cc/onlinePreview?url='+encodeURIComponent("https://"+location.host+"/"+e))
    },
    isimediate_change(e){
       if(e == true){
        this.form1.date =''
       }
    },
    handlebefore (file) {
        const loading = this.$loading({
        lock: true,
        text: "loading......",
      });
        const isLt1M = file.size / 1024 / 1024 < 20;

        // if (!isJPG) {
        //   this.$message.error('上传文件只能是 JPG 格式!')
        // }
        if (!isLt1M) {
          this.$message.error("上传文件大小不能超过 20MB!");
        }
        loading.close();
        return isLt1M;
      
    },
    handonerror () {
      console.log("超时失败");

      const loading = this.$loading({
        lock: true,
        text: "loading......",
      });
      this.$message({
        message: "您的上传已超时，请再次尝试",
        type: "error",
      });
      loading.close();
    },
     handleSuccess (file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: "loading......",
      });
      if (file.success)
      {
        this.form1.filepath = file.response
        // this.UPLOAD_IF = true
        loading.close();
        this.$message({
          message: file.msg,
          type: "success",
        });
        this.$refs.upload.clearFiles();
      } else
      {
        loading.close();
        this.$message({
          message: file.msg,
          type: "error",
        });
        this.$refs.upload.clearFiles();
      }
    },
    plmb_dc(){
      location.href='https://share-ui.oss-cn-shanghai.aliyuncs.com/202308_JJSVMDM/data_template/%E5%B2%97%E4%BD%8D%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0_%E6%A8%A1%E6%9D%BF.xlsx'
    },
    sumit_station (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid)
        {
          if (this.titles == '新增')
          {
            var { data } = await EmployeePositionAddEmployeePosition(this.form);
          } else
          {
            var { data } = await EmployeePositionUpdate(this.form);
          }
          if (data.status == 200)
          {
            this.$message({
              message: data.msg,
              type: 'success',
            });
            this.dialogVisible = false
            // this.$router.push(this.$route.query.back_url);
            this.getModules_search()
          } else
          {
            this.$message({
              message: data.msg,
              type: 'error',
            });
          }
        } else
        {
          return;
        }
      });
    },
    async EmployeeRegionGetEmployeeRegionTrees_fn () {
      const { data } = await EmployeeRegionGetEmployeeRegionTrees();
      this.Employee_list = data.response;
    },
    Level_3and4Change1(e){ 
        // console.log(e.length)
        // this.form.Level_3and4 = e
        if(!e.length){
            this.form.RIDList = []
        this.form.RID = 0
        this.cascader_if = false
        this.cascader_if = true
        return
        }
              this.form.RIDList =  e
        this.form.RID = e[e.length-1]   
        console.log(this.form.RIDList) 
        console.log(this.form.RID) 
        this.cascader_if = false
        this.cascader_if = true
        },
    Level_3and4Change (e) {
        if(!e){
            return
        }
      if (e.length == 1)
      {
        this.form.large_region_name = e[0];
        this.form.small_region_name = e[0];
        this.Employee_list.find((item) => {
          if (item.Name === e[0])
          {
            console.log(item)
            console.log(e[0])
            this.form.RID = item.ID
          }
        })
      } else
      {
        this.form.large_region_name = e[0];
        this.form.small_region_name = e[1];
        this.Employee_list.find((item) => {
          if (item.Name === e[0])
          {
            item.children.find((item2) => {
              if (item2.Name === e[1])
              {
                console.log(item2)
                console.log(e[0])
                this.form.RID = item2.ID
              }
            })
          }
        })
      }
    },
    async plgx_submit(){
        // if(this.form1.isimediate){
        //     this.form1.date =''
        // }
        // if(!this.form1.isimediate && !this.form1.date){
        //      this.$message({
        //         message: "请选择生效时间",
        //         type: "error",
        //     });
        //     return
        // }
        if(!this.form1.filepath){
             this.$message({
                message: "请上传文件",
                type: "error",
            });
            return
        }
       const {data} =await EmployeePosition_ImportPosition(this.form1)
       if(data.success){
        this.$message({
            message: data.msg,
            type: "success",
        });
        this.getModules_search()
        this.dialogVisible1 = false
       }else{
         this.$message({
        message: data.msg,
        type: "error",
      });
       }
    },
    rggx_upload () {
      this.dialogVisible1 = true;
    },
    handleClose (done) {
      done();
    },
    ExportAccount () {
      // let para = this.filters
      let para = this.filters;
      para.page = this.page;
      console.log(para);
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      const loading = this.$loading({
        lock: true,
        text: "loading......",
      });

      EmployeePosition_EmployeePositionExportExcel(para).then((res) => {
        //window.open("http://47.103.87.196:8082" + res.data.msg);
        this.DC_MODE = false
        loading.close()
        window.open('/api'+res.data.response)
      });
    },
    selectCurrentRow (val) {
      this.currentRow = val;
    },
    callFunc (item) {
      this[item.Func].apply(this, item);
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ''
        ? ''
        : util.formatDate.format(
          new Date(row.CreateTime),
          'yyyy-MM-dd'
        );
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getModules();
    },
    getModules_search () {
      this.page = 1;
      this.getModules();
    },
    //获取用户列表
    getModules () {
      let para = this.filters;
      para.page = this.page;
      console.log(para);
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true;
      EmployeePosition_QueryPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel (ids) {
      console.log(ids);
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: ids };
          channel_Delete(para).then((res) => {
            if (util.isEmt.format(res))
            {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success)
            {
              this.$message({
                message: '删除成功',
                type: 'success',
              });
            } else
            {
              this.$message({
                message: res.data.msg,
                type: 'error',
              });
            }

            this.getModules();
          });
        })
        .catch(() => { });
    },
    handleWithdraw (id) {
      // 撤回
      store_data_Reback_Store('store_id=' + id).then((res) => {
        if (res.data.success)
        {
          this.$message({
            message: '撤回成功',
            type: 'success',
          });
          this.getModules();
        } else
        {
          this.$message({
            message: res.data.msg,
            type: 'error',
          });
        }
      });
    },
    handledetails: function (e) {
      this.$router.push({
        path: '/Employee/Employee_details',
        query: {
          id: e.ID,
          type: 'CK',
          back_url: '/Employee/Employee_list',
        },
      });
    },
    handleAdd () {
      // this.$refs['form'].resetFields()
      this.form={
        RID:0,
        RIDList:[]
      }
      //   console.log(this.$refs['form'])
      if (typeof this.$refs['form'] !== 'undefined')
      {
        this.$refs['form'].resetFields();
      }
      this.titles = '新增';
      this.dialogVisible = true;
    },

    //编辑
    handleEdit: function (e) {
      if (typeof this.$refs['form'] !== 'undefined')
      {
        this.$refs['form'].resetFields();
      }
      this.form = JSON.parse(JSON.stringify(e));
      this.form.Level_3and4 =  JSON.parse(JSON.stringify(e.RIDList)) ;
    //   if (this.form.large_region_name == this.form.small_region_name)
    //   {
    //     this.form.Level_3and4.push(this.form.large_region_name);
    //   } else
    //   {
    //     this.form.Level_3and4.push(this.form.large_region_name);
    //     this.form.Level_3and4.push(this.form.small_region_name);
    //   }

      this.titles = '编辑';
      this.dialogVisible = true;
    },
    handledetails_SalesOperation: function (
      ids,
      progress,
      outletnumber__c
    ) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/StoreManage/add_store',
        query: {
          id: ids,
          type: 'store_ck',
          progress: progress,
          approval_type: 'store',
          outletnumber__c: outletnumber__c,
          list_SalesOperation: 1,
        },
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //localStorage 存储数组对象的方法
    saveObjArr (name, data) {
      localStorage.setItem(name, JSON.stringify(data));
    },

    //localStorage 获取数组对象的方法
    getObjArr (name) {
      return JSON.parse(window.localStorage.getItem(name));
    },
    details_tag (name) {
      var router_list = this.getObjArr('router');
      for (let i in router_list)
      {
        for (let s in router_list[i].children)
        {
          //  console.log(999)
          if (router_list[i].children[s].id == '175')
          {
            //  console.log(999)
            router_list[i].children[s].name = name;
            router_list[i].children[s].meta.title = name;
            console.log(router_list[i].children[s].name);
            this.saveObjArr('router', router_list);
            console.log(this.getObjArr('router'));
          }
        }
      }
      //  this.getObjArr('router') = router_list
      console.log(router_list);
    },
  },
  mounted () {
   this.$nextTick(()=>{
        	      this.tableHeight = window.innerHeight - 250;
		})
    console.log(this.getObjArr('router'));
    this.getModules();
    this.EmployeeRegionGetEmployeeRegionTrees_fn();
    let tokenStr = window.localStorage.Token;
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    };
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped></style>
<style>
 .myClass>.el-cascader-panel>.el-scrollbar:first-child>.el-cascader-menu__wrap>ul>li>.el-radio { 
    display: none !important
  }
  .myClass>.el-cascader-panel>.el-scrollbar:nth-child(2)>.el-cascader-menu__wrap>ul>li>.el-radio { 
    display: none !important
  }
</style>